import React, { useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { DELETE_FLASH_MESSAGE } from '../../../actions/flashMessages.actions';
import '../../../influencer/pages/home/CookiesPrompt.scss';
import FlashMessage from "../FlashMessage";

const FlashMessages = () => {
  const dispatch = useDispatch();
  const messages = useSelector(store => store.flashMessages);

  const deleteFlashMessage = useCallback((messageId) => {
    dispatch({ type: DELETE_FLASH_MESSAGE, id: messageId });
  }, [dispatch]);

  if (messages == null || messages.length === 0) return null;

  return <div className="message-wrapper message-top">
    {messages.map(message =>
      <FlashMessage key={message.id}
        message={message}
        deleteFlashMessage={() => deleteFlashMessage(message.id)} />
    )}
  </div>;
};

export default React.memo(FlashMessages);
